export const BASE_URL="https://docs.google.com/forms/u/0/d/1JC-zABOglm4U7-uHkJstAqvpBzEMzAO8ToGH1Y7661I/aggregatestatistics?sid=3d09aeb0dc03cdd5&vc=0&c=0&w=1&flr=0&token=6s5_QX4BAAA.bqXz99bgS0mSM9BPt_K7mA.3GrRMQdi5bhk1NqTGqGfpw"
